import * as React from "react";
import { useContext, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


import { faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from "../../context/auth.context";

import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";


import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LanguageSwitcher from "./LanguageSwitcher";

import { PrincipaleButton } from "../../components/PrincipaleButton";

// width of the sidebar
const drawerWidth = 170;

// this part to be reviewed
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(4),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);


const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(150% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default function SideBarApp() {
  const { t } = useTranslation();
  const { isLoggedIn, logOutUser } = useContext(AuthContext);
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <AppBar position="fixed" open={open}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(open && { display: "none" }) }}
            >
              <MenuIcon />
            </IconButton>
              <>
         
      <a href="/" style={{ display: 'inline-block',marginLeft: '-10px', color: '#fff', textDecoration: 'none', fontSize: '20px', fontWeight: 'bold' }}>
   financebdarija
      </a>


             {/* <a href="/"> <FontAwesomeIcon icon={faHandHoldingDollar} style={{color: "#ffffff",}} />financebdarija </a> */}
                <Box sx={{ flexGrow: 1 }} />
            
                <LanguageSwitcher />
            {!isLoggedIn && (
                <PrincipaleButton href="/login" style={{ marginLeft: '10px' }} margin={{ top: "10px", bottom: "10px" }} fontWeight={400} padding="10px 10px">{t("login")}</PrincipaleButton>
            )}
              </>
            {/* <Typography variant="h6" noWrap component="div"></Typography> here you can add to the top */}
          </Toolbar>
        </AppBar>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            <Sidebar>
              <Menu>
                <MenuItem
                  component={<Link to="/" />}
                  onClick={handleDrawerClose}
                >
                  {t("home")}
                </MenuItem>
                <MenuItem
                  component={<Link to="/podcasts" />}
                  onClick={handleDrawerClose}
                >
                  {t("podcasts")}
                </MenuItem>
                <MenuItem
                  component={<Link to="/budget" />}
                  onClick={handleDrawerClose}
                >
                  {t("budget")}
                </MenuItem>
                {isLoggedIn && (
                  <>
                    <MenuItem
                      component={<Link onClick={logOutUser} />}
                      onClick={handleDrawerClose}
                    >
                      {t("logout")}
                    </MenuItem>
                    <MenuItem
                      component={<Link to="/profile" />}
                      onClick={handleDrawerClose}
                    >
                      {t("profile")}
                    </MenuItem>
                  </>
                )}
                {!isLoggedIn && (
                  <>
                    <MenuItem
                      component={<Link to="/login" />}
                      onClick={handleDrawerClose}
                    >
                       {t("login")}
                    </MenuItem>
                    <MenuItem
                      component={<Link to="/signup" />}
                      onClick={handleDrawerClose}
                    >
                    {t("signup")}
                    </MenuItem>
                  </>
                )}
              </Menu>
            </Sidebar>
          </List>
        </Drawer>
        <Main open={open}>{/* <DrawerHeader /> */}</Main>
      </Box>
    </>
  );
}
